import { baseApi } from '@/api/core/baseApi';
import { unwrapListResponse, unwrapApiResponse } from '@/api/patterns/crud';
import type { BillingPackage, GetPackagesArgs, CreditCategory } from '../types';

export const platformPackagesApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getPlatformPackages: builder.query<BillingPackage[], GetPackagesArgs | void>({
      query: (args) =>
        `/admin/billing/packages?includeInactive=${args?.includeInactive ?? true}`,
      transformResponse: unwrapListResponse<BillingPackage>,
      providesTags: [{ type: 'Packages', id: 'PLATFORM-LIST' }],
    }),

    createPlatformPackage: builder.mutation<BillingPackage, Partial<BillingPackage>>({
      query: (data) => ({
        url: '/admin/billing/packages',
        method: 'POST',
        body: data,
      }),
      transformResponse: unwrapApiResponse<BillingPackage>,
      invalidatesTags: [{ type: 'Packages', id: 'PLATFORM-LIST' }],
    }),

    updatePlatformPackage: builder.mutation<BillingPackage, { id: string; data: Partial<BillingPackage> }>({
      query: ({ id, data }) => ({
        url: `/admin/billing/packages/${id}`,
        method: 'PATCH',
        body: data,
      }),
      transformResponse: unwrapApiResponse<BillingPackage>,
      invalidatesTags: [{ type: 'Packages', id: 'PLATFORM-LIST' }],
    }),

    deactivatePlatformPackage: builder.mutation<void, string>({
      query: (id) => ({
        url: `/admin/billing/packages/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Packages', id: 'PLATFORM-LIST' }],
    }),

    getCreditCategories: builder.query<CreditCategory[], void>({
      query: () => '/admin/billing/credit-categories',
      transformResponse: unwrapListResponse<CreditCategory>,
    }),
  }),
});

export const {
  useGetPlatformPackagesQuery,
  useCreatePlatformPackageMutation,
  useUpdatePlatformPackageMutation,
  useDeactivatePlatformPackageMutation,
  useGetCreditCategoriesQuery,
} = platformPackagesApi;
